// extracted by mini-css-extract-plugin
module.exports = {"container":"e_On","floatingBox":"e_Pn","floatingAd":"e_Qn"};